import * as React from "react";

import {
    ACCOUNT_SETTINGS_QUERY,
    mapDataToResult,
    type AccountSettingsQueryResult,
} from "@repo/user-settings";

import ApolloQuery from "#data-access/gql/apollo-query.tsx";

interface Props {
    targetKaid: string;
    children: (result: AccountSettingsQueryResult) => React.ReactNode;
}

export const AccountSettingsQuery: React.FC<Props> = ({
    targetKaid,
    children,
}) => {
    return (
        <ApolloQuery
            query={ACCOUNT_SETTINGS_QUERY}
            variables={{targetKaid}}
            fetchPolicy="cache-and-network"
        >
            {(result) => children(mapDataToResult(result))}
        </ApolloQuery>
    );
};

export const DATA_QUERY_FOR_TEST = ACCOUNT_SETTINGS_QUERY;
